import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Copyright from "../internals/components/Copyright";
import CustomizedDataGrid from "./CustomizedDataGrid";
import PageViewsBarChart from "./PageViewsBarChart";
import CustomerDepositReport from "./deposits/CustomerDepositReport.js";
import AgentBalances from "./crypto/AgentBalances.js";

export default function MainGrid({token, id, isAuthenticated, setIsAuthenticated}) {
	return (
		<Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
			{/* cards */}
			<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
				Overview
			</Typography>
			<Grid container columns={12}>
				<Grid size={{ xs: 12, md: 12, lg: 12 }}>
					<AgentBalances token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}/>
				</Grid>
			</Grid>
			<Typography component="h2" variant="h6" sx={{ mb: 2, mt:2 }}>
				Latest Deposits
			</Typography>
			<Grid container columns={12}>
				<Grid size={{ xs: 12, lg: 12 }}>
					<CustomerDepositReport token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}/>
				</Grid>
			</Grid>
			<Copyright sx={{ my: 4 }} />
		</Box>
	);
}
